import * as React from 'react';
import { CircleButton, CircleButtonProps } from '@minecraft.atoms';
import { BaseDropdownButton } from './BaseDropdownButton';
import { DropdownItemProps, OptionalProps } from './types';

export interface CircleDropdownButtonProps extends OptionalProps {
  toggleProps: Pick<CircleButtonProps, 'color' | 'size' | 'icon' | 'variant' | 'label'>;
  menuItemsProps: DropdownItemProps[];
  menuChildren?: React.ReactNode;
  menuAlign?: 'right' | 'left';
  block?: boolean;
  mobileBlock?: boolean;
}

export const CircleDropdownButton = (props: CircleDropdownButtonProps) => (
  <BaseDropdownButton
    {...props}
    toggleComponent={CircleButton}
    // No children in toggle for circle button (icon only)
  />
);
